/**
 * Retry a function with exponential backoff on timeout errors
 * @param {Function} fn - Async function to retry
 * @param {number} maxRetries - Maximum retry attempts (default: 3)
 * @param {number} baseDelayMs - Base delay in milliseconds (default: 1000)
 * @returns {Promise} Result of the function
 */
async function retryWithBackoff(fn, maxRetries = 3, baseDelayMs = 1000) {
  let lastError;

  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;

      const isTimeoutError =
        error.code === 'ECONNABORTED' ||
        error.message?.includes('timeout') ||
        error.message?.includes('timeout error') ||
        error.message?.includes('ECONNABORTED');

      if (isTimeoutError && attempt < maxRetries - 1) {
        const delay = Math.pow(2, attempt + 1) * baseDelayMs;
        await new Promise(resolve => setTimeout(resolve, delay));
        continue;
      }

      throw error;
    }
  }

  throw lastError;
}

export { retryWithBackoff };
